import React from 'react';
import {useNavigate} from 'react-router-dom';
import { Warning } from '@phosphor-icons/react';
import {Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,} from '@/components/ui/dialog';
import {Button} from '@/components/ui/button';
import {useSessionExpired} from '@/contexts/SessionExpiredContext';

export function SessionExpiredModal() {
  const navigate = useNavigate();
  const { isModalOpen, hideSessionExpiredModal } = useSessionExpired();

  const handleVerifyIdentity = () => {
    hideSessionExpiredModal();
    const currentPath = window.location.pathname + window.location.search;
    navigate(`/login?returnTo=${encodeURIComponent(currentPath)}`);
  };

  const handleModalChange = (open: boolean) => {
    if (!open) {
      hideSessionExpiredModal();
      const currentPath = window.location.pathname + window.location.search;
      navigate(`/login?returnTo=${encodeURIComponent(currentPath)}`);
    }
  };

  return (
    <Dialog open={isModalOpen} onOpenChange={handleModalChange}>
      <DialogContent className="sm:max-w-md p-0 gap-0 overflow-hidden">
        <DialogHeader variant="bordered">
          <DialogTitle className="flex items-center gap-2">
            <Warning className="h-5 w-5 text-red-600" />
            Session Expired
          </DialogTitle>
          <p className="text-sm text-muted-foreground">
            Your session has expired for security reasons. Please log in again to continue.
          </p>
        </DialogHeader>

        <DialogFooter variant="bordered">
          <Button onClick={handleVerifyIdentity}>
            Log In Again
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
